import React from 'react';
import { GIButton, Modal } from 'app-components';
import styled from 'styled-components';

const StyledModalBody = styled.div`
    .gi-modal__content {
            width: 30% !important;
            padding-bottom: 0px;
    }
    .template-form__input{
            margin-bottom:0 !important
    }
`;

const TemplateAPIResponseModal = props => {
    const { submitBtnText, message, headerId, onClose } = props;
    return (
        <StyledModalBody>
            <Modal id="tempate_api_response">
                <Modal.Header
                    id="ticket_management.tempate_api_response_modal_title"
                    titleId={headerId}
                    onHide={onClose}
                    data-testid={`${headerId}_close_button`}
                />
                <Modal.Body>
                    <div>{message}</div>
                </Modal.Body>
                <Modal.Controls>
                    <div
                        className="tempate_api_response_controls"
                        data-testid="ticket_management_tempate_api_response_controls"
                    >
                        <GIButton
                            dataTestId={`${headerId}_ok_button`}
                            id="tempateApiResponse"
                            labelId={submitBtnText}
                            onClickHandler={onClose}
                        />
                    </div>
                </Modal.Controls>
            </Modal>
        </StyledModalBody>
    );
};
export default TemplateAPIResponseModal;
